// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c9895b52","453":"f6a56b7c","455":"1ce6fddf","977":"d2c0a3af"}[chunkId] + ".chunk.js";
};